export default __webpack_public_path__ + "theme/assets/no-image-3041b99b.svg";